import Cookies from "js-cookie";

export default class HomeCtaHandler {

    constructor(tempCookieId, messageModal) {
        this.clientId = LINKEDIN_CLIENT_ID;
        this.state = LINKEDIN_STATE;
        this.appUrl = APP_URL;
        this.getStartedUrl = GET_STARTED_URL;
        this.cta = $(".cta");
        this.tempCookieId = tempCookieId;
        this.messageModal = messageModal;
    }

    init() {
        const self = this;
        const referrer = document.referrer;
        self.cta.each(function () {
            let href = self.getStartedUrl + "?";
            let refId = Cookies.get('refId');
            const state = {};
            if (refId) {
                state.refId = refId;
                href = href + "refId=" + refId;
            }
            const classes = $(this).attr('class').split(" ");
            const flow = classes.find(className => className.indexOf("flow") >= 0);
            let flowName;

            if (flow) {
                flowName = flow.substring(flow.indexOf("-") + 1);
                href = href + "&flow=" + flowName;
            }
            if (referrer && (referrer.indexOf("linkedin.com") >= 0 || referrer.indexOf("facebook.com") >= 0)) {
                href = href + "&tr=true";
            }
            $(this).attr("href", href);
        });
    }

}